import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Mail, Loader2, ArrowLeft, CheckCircle2, ShieldCheck } from "lucide-react";
import { HOSPITAL } from "@/lib/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSubmitted(true);
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Gagal mengirim permintaan");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-100 via-blue-50 to-slate-100 p-6">
      <div
        data-testid="forgot-password-page"
        className="w-full max-w-md bg-white rounded-3xl shadow-xl border border-slate-100 overflow-hidden"
      >
        <div className="bg-gradient-to-r from-blue-900 to-slate-900 p-6 text-white text-center">
          <img
            src={HOSPITAL.logo}
            alt="Logo"
            className="h-14 w-14 rounded-2xl object-cover mx-auto mb-3 ring-2 ring-white/10"
          />
          <div className="font-heading font-bold text-lg">RS Bhayangkara Tarakan</div>
          <div className="text-xs text-blue-200/80 mt-1">Reset Password Admin</div>
        </div>

        <div className="p-8">
          {!submitted ? (
            <form onSubmit={handleSubmit}>
              <h1 className="font-heading text-xl font-bold text-slate-900 mb-2">
                Lupa Password
              </h1>
              <p className="text-sm text-slate-500 mb-6 leading-relaxed">
                Masukkan email admin Anda. Kami akan mengirim tautan untuk
                membuat password baru — berlaku 1 jam.
              </p>

              <label className="block text-sm font-medium text-slate-700 mb-2">
                <Mail className="inline h-4 w-4 mr-1 text-blue-700" />
                Alamat Email
              </label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-password-email"
                placeholder="anda@rsbhayangkaratarakan.id"
                className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-blue-800 focus:ring-2 focus:ring-blue-100 outline-none text-sm mb-4"
              />

              {error && (
                <div
                  data-testid="forgot-password-error"
                  className="mb-4 p-3 rounded-xl bg-red-50 border border-red-100 text-xs text-red-700"
                >
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={loading}
                data-testid="forgot-password-submit"
                className="w-full inline-flex items-center justify-center gap-2 bg-blue-800 hover:bg-blue-900 disabled:opacity-60 text-white font-medium px-6 py-3 rounded-full transition shadow-md shadow-blue-900/20"
              >
                {loading ? (
                  <Loader2 className="h-4 w-4 animate-spin" />
                ) : (
                  <Mail className="h-4 w-4" />
                )}
                Kirim Tautan Reset
              </button>
            </form>
          ) : (
            <div data-testid="forgot-password-success" className="text-center">
              <div className="h-16 w-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4">
                <CheckCircle2 className="h-8 w-8 text-emerald-600" />
              </div>
              <h1 className="font-heading text-xl font-bold text-slate-900 mb-2">
                Tautan Telah Dikirim
              </h1>
              <p className="text-sm text-slate-600 leading-relaxed mb-4">
                Jika email <b>{email}</b> terdaftar sebagai admin, kami telah
                mengirim tautan reset password. Silakan cek inbox (dan folder
                spam) dalam beberapa menit.
              </p>
              <div className="p-3 rounded-xl bg-blue-50 border border-blue-100 text-xs text-blue-900 mb-4 text-left">
                <b>Tautan berlaku 1 jam.</b> Setelah waktu ini kadaluwarsa, Anda
                perlu meminta ulang.
              </div>
            </div>
          )}

          <div className="mt-6 pt-4 border-t border-slate-100 text-center">
            <Link
              to="/admin/login"
              data-testid="forgot-password-back-login"
              className="inline-flex items-center gap-1 text-xs text-slate-500 hover:text-blue-800"
            >
              <ArrowLeft className="h-3 w-3" />
              Kembali ke Login
            </Link>
          </div>

          <div className="mt-4 pt-3 border-t border-slate-100 flex items-center justify-center gap-2 text-xs text-slate-400">
            <ShieldCheck className="h-3.5 w-3.5" />
            Untuk keamanan, kami tidak konfirmasi apakah email terdaftar.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
